export const IDLE_THRESHOLD = 150;
